var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleGift(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 64 64",
    height: "64px",
    viewBox: "0 0 64 64",
    width: "64px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    fill: "#76C2AF",
    r: 32
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52,50c0,2.209-1.791,4-4,4H16c-2.209,0-4-1.791-4-4V18c0-2.209,1.791-4,4-4h32c2.209,0,4,1.791,4,4V50z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52,48c0,2.209-1.791,4-4,4H16c-2.209,0-4-1.791-4-4V16c0-2.209,1.791-4,4-4h32c2.209,0,4,1.791,4,4V48z",
    fill: "#C75C5C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#231F20",
    height: 40,
    width: 4,
    x: 24,
    y: 14
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#231F20",
    height: 4,
    width: 40,
    x: 12,
    y: 30
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#F5CF87",
    height: 40,
    width: 4,
    x: 24,
    y: 12
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#F5CF87",
    height: 4,
    width: 40,
    x: 12,
    y: 28
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.033,22.033c-1.254-1.254-2.899-1.882-4.543-1.882c-1.644,0-3.288,0.627-4.543,1.882    c-1.83,1.83-1.99,4.549-1.944,7.547c-0.63-0.291-4.858-2.38-5.276-6.186c-0.09-0.823-0.835-1.415-1.655-1.327    c-0.823,0.091-1.417,0.832-1.327,1.655c0.392,3.565,2.86,5.949,4.796,7.301c-2.237,0.087-4.222,0.492-5.659,1.929    c-2.509,2.509-2.509,6.577,0,9.086c1.254,1.255,2.899,1.882,4.543,1.882c1.644,0,3.288-0.627,4.543-1.882    c1.721-1.72,1.966-4.225,1.951-7.01c0.102,0.108,0.216,0.207,0.352,0.283c0.047,0.026,4.647,2.655,4.647,6.773    c0,0.829,0.671,1.5,1.5,1.5s1.5-0.671,1.5-1.5c0-4.851-4.008-7.978-5.576-9.015c2.657-0.006,5.037-0.296,6.692-1.95    C38.542,28.609,38.542,24.542,36.033,22.033z M22.846,39.916c-0.647,0.647-1.507,1.003-2.422,1.003    c-0.915,0-1.775-0.356-2.422-1.003c-1.335-1.335-1.335-3.508,0-4.843C18.765,34.311,20.114,34,22.66,34    c0.408,0,0.823,0.007,1.243,0.016C23.96,36.627,23.924,38.838,22.846,39.916z M33.911,28.997    c-0.762,0.762-2.111,1.073-4.657,1.073c-0.408,0-0.823-0.007-1.243-0.016c-0.057-2.611-0.021-4.822,1.057-5.9    c0.647-0.647,1.507-1.003,2.422-1.003s1.775,0.356,2.422,1.003C35.246,25.489,35.246,27.662,33.911,28.997z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.49,21.151c0.915,0,1.775,0.356,2.422,1.003c1.335,1.335,1.335,3.508,0,4.843    c-0.762,0.762-2.111,1.073-4.657,1.073c-0.408,0-0.823-0.007-1.243-0.016c-0.057-2.611-0.021-4.822,1.057-5.9    C29.715,21.507,30.575,21.151,31.49,21.151 M31.49,18.151c-1.644,0-3.288,0.627-4.543,1.882    c-2.509,2.509-1.882,6.684-1.882,10.967c1.428,0,2.844,0.07,4.19,0.07c2.692,0,5.105-0.279,6.778-1.951    c2.509-2.509,2.509-6.577,0-9.086C34.778,18.778,33.134,18.151,31.49,18.151L31.49,18.151z",
    fill: "#F5CF87"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.66,32c0.408,0,0.823,0.007,1.243,0.016c0.057,2.612,0.021,4.822-1.057,5.9    c-0.647,0.647-1.507,1.003-2.422,1.003s-1.775-0.356-2.422-1.003c-1.335-1.335-1.335-3.508,0-4.843    C18.765,32.311,20.114,32,22.66,32 M22.66,29c-2.692,0-5.105,0.279-6.778,1.951c-2.509,2.509-2.509,6.577,0,9.086    c1.254,1.254,2.899,1.882,4.543,1.882s3.288-0.627,4.543-1.882c2.509-2.509,1.882-6.684,1.882-10.967    C25.422,29.07,24.006,29,22.66,29L22.66,29z",
    fill: "#F5CF87"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.417,41.583c-0.828,0-1.5-0.672-1.5-1.5c0-4.118-4.601-6.747-4.647-6.772    c-0.721-0.405-0.98-1.317-0.578-2.04c0.402-0.722,1.312-0.983,2.035-0.583c0.253,0.141,6.19,3.496,6.19,9.396    C34.917,40.911,34.245,41.583,33.417,41.583z",
    fill: "#F5CF87"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.502,30.5c-0.192,0-0.389-0.037-0.578-0.116c-0.267-0.111-6.534-2.798-7.18-8.662    c-0.091-0.823,0.504-1.564,1.327-1.655c0.821-0.089,1.564,0.504,1.655,1.327c0.453,4.126,5.307,6.202,5.355,6.223    c0.764,0.319,1.124,1.198,0.805,1.963C25.646,30.154,25.089,30.5,24.502,30.5z",
    fill: "#F5CF87"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGift);
export default __webpack_public_path__ + "static/media/circle-gift.f64873795be006a01ff7ff37f216af82.svg";
export { ForwardRef as ReactComponent };